import { useId } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/** Empty means not auto-invoiced; invalid or negative values are rejected. */
export function parseMonthlyPrice(value: string): number | null | undefined {
  const trimmed = value.trim();
  if (!trimmed) return null;

  const parsed = Number(trimmed);
  if (!Number.isFinite(parsed) || parsed < 0) return undefined;
  return Math.round(parsed * 100) / 100;
}

export function formatMonthlyPriceInput(value: number | null | undefined): string {
  return value === null || value === undefined ? "" : String(value);
}

export function MonthlyPriceField({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  const id = useId();

  return (
    <div className="space-y-2">
      <Label htmlFor={id}>Monthly Price</Label>
      <Input
        id={id}
        type="number"
        min="0"
        step="0.01"
        inputMode="decimal"
        placeholder="Leave blank to skip automatic invoicing"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      <p className="text-xs text-muted-foreground">
        Billed to the property owner as a draft invoice a few days after each calendar month ends.
      </p>
    </div>
  );
}
